'use strict';

bbw.model.PhotoPrivateCollection = ngtk.model.List.extend({

    statics: {
        REQUEST_TMPL: 'user/chat/get-private-photos/{contact_user_id}/{photo_ids}/{size_name}/{full_size_name}'
    },

    _itemModel: bbw.model.Photo,

    _count: undefined,

    _loadArgs: undefined,

    load: function(contact_user_id, photo_ids, size_name, full_size_name) {
        if (!angular.isArray(photo_ids) || !photo_ids.length) {
            throw new Error('Empty photo_ids, or not an array');
        }
        this._loadArgs = {
            contact_user_id: contact_user_id,
            photo_ids: photo_ids,
            size_name: size_name || undefined,
            full_size_name: full_size_name || undefined
        };
        return this._load();
    },

    getCount: function() {
        return this._count;
    },

    reload: function() {
        return this._load();
    },

    _load: function() {
        if (angular.isUndefined(this._loadArgs)) {
            throw new Error('loadArgs not defined');
        }
        var attrs = angular.copy(this._loadArgs);
        angular.extend(attrs, {
            size_name: attrs.size_name || '',
            full_size_name: attrs.full_size || ''
        });
        return this._loadFromApi('get', bbw.model.PhotoPrivateCollection.REQUEST_TMPL, attrs).then(function(response) {
            this._setFromApiResult(response.photos);
            this._count = response.photos.length;
        }.bind(this));
    }

});